// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I02d-","right":"styles_right__2v2UY"};